import { TypedTensor } from "onnxruntime-web"
import z from "zod"

export type OnnxModelResult = {
  // view model result -> Exterior, Other, Interior
  output_space_type: TypedTensor<"float32">
  // view model result confidence -> number between 0 - 1 aka probability 0.87 -> 87%
  softmax_space_type: TypedTensor<"float32">
  // quality model result
  output_quality: TypedTensor<"float32">
  // quality model result confidence
  softmax_quality: TypedTensor<"float32">
}

export const ModelQualityLabel = {
  Ok: "OK",
  FromScreen: "from_screen",
  Blur: "blur",
  Dark: "dark",
  Light: "light",
} as const

// DO NOT CHANGE THE ORDER OF THESE LABELS
export const MODEL_VIEW_LABELS = ["Exterior", "Other", "Interior"] as const

export type ModelViewLabel = (typeof MODEL_VIEW_LABELS)[number]

// DO NOT CHANGE THE ORDER OF THESE LABELS
export const MODEL_QUALITY_LABELS = [
  ModelQualityLabel.Ok,
  ModelQualityLabel.Dark,
  ModelQualityLabel.Blur,
  ModelQualityLabel.Light,
  ModelQualityLabel.FromScreen,
] as const

const predictionResultSchema = <T extends z.ZodTypeAny>(labelSchema: T) =>
  z.object({
    label: labelSchema.optional(),
    confidence: z.number().optional(),
    index: z.number(),
  })

const viewLabelSchema = z.enum(MODEL_VIEW_LABELS)
const qualityLabelSchema = z.enum(MODEL_QUALITY_LABELS)

export const predictResponseSchema = z.object({
  view: predictionResultSchema(viewLabelSchema),
  quality: predictionResultSchema(qualityLabelSchema),
  preprocessTime: z.number(),
  predictTime: z.number(),
  isConfident: z.boolean(),
})

export type PredictResponse = z.infer<typeof predictResponseSchema>
